import BaseClass from "../../util/BaseClass";
import Context from "../../context/Context";
import {WorkingController} from "../../common/components/Modal";

export default class TransactionGuard extends BaseClass {

  workingController;
  timestamp;

  constructor(props) {
    super(props);
    if (props && props.featureItems && props.featureItems.length > 1) {
      const i18n = Context.instance.i18n;
      const content = i18n.spaceplanner.transactionGuard.message;
      this.timestamp = Date.now();
      this.workingController = new WorkingController();
      this.workingController.show({}, content);
    }
  }

  close() {
    const wc = this.workingController;
    this.workingController = null;
    if (wc) {
      // ensure that the guard is visible for at least 2 seconds
      let millis = 2000 - (Date.now() - this.timestamp);
      if (millis < 1) millis = 1;
      setTimeout(() => {
        wc.close();
      }, millis);
    }
  }

}
